import React,{Component} from 'react'
import Header from '../common/checkHeader.jsx';
import Footer from '../common/checkFooter.jsx';
import {getCookie} from '../../common/service/common'
import Login from '../common/checklogin'
export default class Check extends Component{
    constructor(){
        super();
        this.state={
            loginFlag:false,
            listData:[],
        }
    }
    getCheckBtn(item){
        this.props.history.push('/index/from/'+item.goods_code+'/'+item.goods_name);
    }
    getLoginBtn(e){
        e.nativeEvent.stopImmediatePropagation();
        this.setState({
            loginFlag:true
        })
    }
    onLogin=()=>{
        this.setState({
            loginFlag:true,
        })
    }
    getLogin=()=>{
        this.setState({
            loginFlag:false,
        })
    }
    componentDidMount(){
        React.$http.paperCheckIndexReady().then((res)=>{
            if(res&&res.success){
                this.setState({
                    listData:res.list
                })
            }
        });
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        };
    }
    render(){
        const {
            loginFlag,
            listData
        } = this.state;
        const sid = getCookie("z_sid");
        return(
            <div className="containers">
                {loginFlag?(<Login getLogin={this.getLogin}></Login>):''}
                <Header onLogin={this.onLogin}></Header>
                <div className="mains">
                    <div className="mainban">
                        <div className="banner">
                            <div className="bannerTit">文献相似性检测服务</div>
                            <div className="bannerCon">EPS DATA与万方数据合作，推出文献相似性检测服务(论文查重)，文献相似性检测服务采用科学先进的检测技术，实现海量学术文献数据全文比对，秉持客观、公正、精准、全面的服务原则，为用户提供精准详实的相似性检测结果，呈现多版本、多维度的检测报告。</div>
                        </div>
                    </div>
                    <div className="mains_wrap martop1">
                        <div className="title">
                            <div className="title_box">
                                <div className="title_text">请选择查询版本</div>
                            </div>
                        </div>
                        <div className="conten">
                            {
                                listData&&listData.map((v,k)=>(
                                    <div className="itembox" key={k}>
                                        <div className="title-item">{v.goods_name}</div>
                                        <div className="con-item">
                                            <div className="item_key"><span className="moneny">¥{v.countPrice&&v.countPrice.showPrice}</span>/{v.countPrice&&v.countPrice.min_unit}</div>
                                            <div className="item_show">
                                                <span className="linespan">原价：¥{v.countPrice.showPrice/0.9}/万字</span>
                                                <span className="linetext">限时九折</span>
                                            </div>
                                            {
                                                v.piecePrice&&v.piecePrice.showPrice!==-1?(
                                                    <div>
                                                        <div className="item_key">或</div>
                                                        <div className="item_key"><span className="moneny">{v.piecePrice&&v.piecePrice.showPrice}</span>元/{v.piecePrice&&v.piecePrice.min_unit}</div>
                                                    </div>
                                                ):('')
                                            }
                                            
                                            <div className="item_keys">{v.memo}</div>
                                        </div>
                                        {
                                            sid?(
                                                <div className="btn-item" onClick={this.getCheckBtn.bind(this,v)}>立即检测</div>
                                            ):(
                                                <div className="btn-item" onClick={(e)=>this.getLoginBtn(e)}>立即检测</div>
                                            )
                                        }
                                    </div>
                                ))
                            }
                            <div className="clear"></div>
                        </div>
                    </div>
                    <div className="mains_wrap martop2">
                        <div className="title">
                            <div className="title_box">
                                <div className="title_text">产品特点</div>
                            </div>
                        </div>
                        <div className="conten">
                            <div className="itemBack">
                                <div className="labimg"><span className="ico_paper paper1"></span></div>
                                <div className="labtit">多元化用户场景</div>
                                <div className="content">覆盖多类用户群体与用户使用场景，实现专业场景化精准服务</div>
                            </div>
                            <div className="itemBack">
                                <div className="labimg"><span className="ico_paper paper2"></span></div>
                                <div className="labtit">便捷安全的过程</div>
                                <div className="content">传输存储技术安全可靠保护您的文献不被泄露检测过程放心安心</div>
                            </div>
                            <div className="itemBack">
                                <div className="labimg"><span className="ico_paper paper3"></span></div>
                                <div className="labtit">海量学术全文资源</div>
                                <div className="content">上亿篇期刊、会议、学位 论文、专利、报纸、学术价值的网络资源</div>
                            </div>
                            <div className="itemBack">
                                <div className="labimg"><span className="ico_paper paper4"></span></div>
                                <div className="labtit">多维检测结果</div>
                                <div className="content">多种知识图谱可视化分析图解详细说明图文结合，直观详尽</div>
                            </div>
                            <div className="itemBack">
                                <div className="labimg"><span className="ico_paper paper5"></span></div>
                                <div className="labtit">科学先进检测技术</div>
                                <div className="content">自主知识产权的全新检测算法检测高效精准、速度快</div>
                            </div>
                            <div className="clear"></div>
                        </div>
                    </div>
                    <div className="mains_wrap martop2">
                        <div className="title">
                            <div className="title_box">
                                <div className="title_text">资质展示</div>
                            </div>
                        </div>
                        <div className="conten" style={{display:'flex',justifyContent: 'space-between'}}>
                            <a href="/assets/licenceOne.png" style={{width: '50%'}} target="_blank" rel="noopener noreferrer"><img src="/assets/licenceOne.png" style={{width:'100%'}} alt=""/></a>
                            <a href="/assets/licenceOne.png" style={{width: '50%'}} target="_blank" rel="noopener noreferrer"><img src="/assets/licenceTwo.png" style={{width:'100%'}} alt=""/></a>
                        </div>
                    </div>
                </div>
                <Footer></Footer>
            </div>
        )
    }
}
